module.exports = __webpack_public_path__ + "img/blue-skyscraper.66e0b3f9.jpg";